<div class="container">
  <div class="content">
    <h1 nxHeadline class="nx-font-weight-bold">{{ 'Legal Notice' | transloco }}</h1>

    <h2 nxHeadline class="nx-font-weight-bold">{{ 'The publisher of the website is:' | transloco }}</h2>
    <p>
      {{ 'Euler Hermes Recouvrement France A Simplified Joint Stock Company with a capital of 800,000 euros Registered
      office: 1, Place des Saisons – 92048 Paris La Défense Cedex RCS Nanterre: B 388 237 026 Tel: +33 1 84 11 50 50
      Email: stripeadmin@eulerhermes.com' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'The Publication Director is:' | transloco }}</h2>
    <p>
      {{ 'Mr. Hubert Leman, President of Euler Hermes Recouvrement France' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Hosting is provided by:' | transloco }}</h2>
    <p>
      {{ 'This site is hosted exclusively on data centers in Europe (Germany) by: Amazon Web Services (AWS) Amazon Web
      Services Inc. 410 Terry Avenue North Seattle, WA 98109-5210, USA https:\/\/aws.amazon.com' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Copyright' | transloco }}</h2>
    <p>
      {{ 'This site and each of its components, including graphics, texts, and images, are protected by copyright law.
      Any reproduction or distribution of any element of the site by any means constitutes an infringement punishable
      under the Intellectual Property Code.' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Website Design' | transloco }}</h2>
    <p>{{ 'Website designed by Euler Hermes.' | transloco }}</p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Liability' | transloco }}</h2>
    <p>
      {{ 'Euler Hermes Recouvrement France shall in no event be liable for indirect damages, such as financial or
      commercial loss, loss of profit, business disruption, lost earnings, or claims made by third parties against the
      user resulting from the use of this site or any information obtained from it.' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Viruses' | transloco }}</h2>
    <p>
      {{ 'It is your responsibility to take all appropriate measures to protect your own data, software, and hardware
      from contamination by viruses.' | transloco }}
    </p>

    <h2 nxHeadline  class="nx-font-weight-bold">{{ 'Service Availability' | transloco }}</h2>
    <p>
      {{ 'We are committed to making our best efforts to ensure that all services available on our website remain
      accessible. Our obligations are based on a best-effort approach, and as such, our liability cannot be engaged in
      the following cases:' | transloco }}
    </p>
  </div>
</div>
